// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__Dn2Y_","footer":"style_footer__xMFk8"};